
// FilterHelpers
window.FilterHelpers = {
    debounce(func, wait = 300) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    },

    uniqueProducts(arr) {
        const map = {};
        arr.forEach((p) => (map[p.handle] = p));
        return Object.values(map);
    },

    levenshteinDistance(s1, s2) {
        if (s1.length < s2.length) [s1, s2] = [s2, s1];
        if (s2.length === 0) return s1.length;

        let prevRow = Array.from({ length: s2.length + 1 }, (_, i) => i);

        for (let i = 0; i < s1.length; i++) {
            let currRow = [i + 1];
            for (let j = 0; j < s2.length; j++) {
                const insertions = prevRow[j + 1] + 1;
                const deletions = currRow[j] + 1;
                const substitutions = prevRow[j] + (s1[i] === s2[j] ? 0 : 1);
                currRow.push(Math.min(insertions, deletions, substitutions));
            }
            prevRow = currRow;
        }

        return prevRow[s2.length];
    },
};

// UI
window.FilterUI = {
    initAsideFilter(asideItems) {
        asideItems.forEach((item) => {
            const title = item.querySelector('.aside-title');
            const content = item.querySelector('.aside-content');

            title?.addEventListener('click', (e) => {
                e.stopPropagation();

                if (window.innerWidth >= 768) {
                    asideItems.forEach((other) => {
                        if (other !== item) other.classList.remove('active');
                    });
                }

                item.classList.toggle('active');
            });

            content?.addEventListener('click', (e) => e.stopPropagation());
        });

        document.addEventListener('click', () => {
            if (window.innerWidth >= 768) {
                asideItems.forEach((item) => item.classList.remove('active'));
            }
        });

        const syncActiveState = () => {
            if (window.innerWidth < 768) {
                asideItems.forEach((item) => item.classList.add('active'));
            } else {
                asideItems.forEach((item) => item.classList.remove('active'));
            }
        };

        syncActiveState();
        window.addEventListener('resize', syncActiveState);
    },

    initMobileFilter() {
        const btnFilter = document.querySelector('.button-filter-mobile');
        const listFilter = document.querySelector('.list-filter');
        const overlay = document.querySelector('.background-overlay');
        const close = document.querySelector('.close-filter');
        const btnApply = document.querySelector('.btn-apply-filter');

        if (!btnFilter || !listFilter || !overlay) return;

        const closeFilterMobile = () => {
            listFilter.classList.remove('open');
            document.body.style.overflow = '';
        };

        btnFilter.addEventListener('click', () => {
            if (window.innerWidth >= 768) return;
            const isActive = listFilter.classList.toggle('open');
            document.body.style.overflow = isActive ? 'hidden' : '';
        });

        overlay.addEventListener('click', () => {
            if (window.innerWidth < 768) closeFilterMobile();
        });

        close?.addEventListener('click', () => {
            if (window.innerWidth < 768) closeFilterMobile();
        });

        btnApply?.addEventListener('click', () => {
            if (window.innerWidth < 768) closeFilterMobile();
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 768) closeFilterMobile();
        });
    },

    showLoading(overlay, spinner) {
        overlay?.classList.add('loading');
        spinner?.classList.remove('hidden');
    },

    hideLoading(overlay, spinner) {
        overlay?.classList.remove('loading');
        spinner?.classList.add('hidden');
    },

    updateCheckedCount() {
        const count = document.querySelectorAll(".list-filter input[type='checkbox']:checked").length;
        const countEl = document.querySelector('.filter-count');
        if (countEl) countEl.textContent = count > 0 ? `(${count})` : '';
    },
};
